export default __webpack_public_path__ + "static/media/pack_tab@2x.96ff3c75.png";